/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import {
  pull_value_sini_object,
  set_value_sini,
  fly_init_update,
} from "../../App/actions/sini_v2";
import { set_demography } from "../../App/actions/set_demography";

/*PICTURE*/
import icon_expand_bottom from "../../Assets/svg/icon_expand_bottom.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class SINI_DEMOGRAPHY extends Component {
  state = {};

  on_set_sini_menu_active = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "demography_properties",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["demography_properties", "demography_intersect_list"],
    });
  };

  on_activate_sini_ai = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "post_ai_chat",
    });
  };

  on_set_demography = () => {
    const { request_id_active, ai_parent_detail_list } = this.props.sini;
    const sini_object = ai_parent_detail_list.find(
      (item) => item.request_id === request_id_active
    );
    const { request_id, geojson_polygon_isochrone, lat, long } = sini_object;
    const params = {
      request_id,
      geojson_polygon_isochrone,
      lat,
      long,
    };
    this.props.set_demography(params);
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { request_id_active, ai_parent_detail_list } = this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const sini_object = ai_parent_detail_list.find(
      (item) => item.request_id === request_id_active
    );
    const demography_properties = sini_object?.demography_properties || {};
    const demography_list = sini_object?.demography_list || [];

    const content = (
      <section className="container_light background_white margin_bottom outline_grey">
        <table className="full_width">
          <tbody>
            <tr>
              <td className="text_left">
                <div
                  className="badge background_grey_light margin_bottom"
                  onClick={this.on_set_sini_menu_active}
                >
                  {dict?.["Demographics"]?.[language]}
                </div>
                {demography_list.length > 0 ? (
                  <>
                    <section className="margin_bottom">
                      <p className="text_medium sub_color">
                        {dict?.["Total Population"]?.[language]}
                      </p>
                      <p className="text_bold">
                        {new Intl.NumberFormat("id-ID", {
                          style: "decimal",
                        }).format(
                          demography_properties?.["JUMLAH PENDUDUK"] ||
                            demography_properties?.["JUMLAH PENDUDUK 2024"]
                        )}
                      </p>
                    </section>
                    <section className="margin_bottom">
                      <p className="text_medium sub_color">
                        {dict?.["Administrative address"]?.[language]}
                      </p>
                      <p className="text_bold">
                        {demography_properties?.["DESA"] ||
                          demography_properties?.["DESA ATAU KELURAHAN"] ||
                          " "}
                        , {demography_properties?.["KECAMATAN"]},{" "}
                        {demography_properties?.["KABKOT"] ||
                          demography_properties?.["KABUPATEN ATAU KOTA"] ||
                          " "}
                        , {demography_properties?.["PROVINSI"]}
                      </p>
                    </section>
                  </>
                ) : (
                  <>
                    {loading_item_array.length === 0 && (
                      <div>
                        <p className="text_medium margin_bottom">
                          {
                            dict?.[
                              "Demographics do not yet use proportional"
                            ]?.[language]
                          }
                        </p>
                        {!loading_item_array.includes("set_demography") ? (
                          <button
                            className="button background_black"
                            onClick={this.on_set_demography}
                          >
                            {dict?.["Update"]?.[language]}
                          </button>
                        ) : (
                          <button className="button background_grey">
                            {dict?.["Updating"]?.[language]} ...
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
        {demography_list.length > 0 && (
          <div className="text_center">
            <img
              alt="expand"
              src={icon_expand_bottom}
              width={45}
              className="cursor_pointer"
              onClick={this.on_set_sini_menu_active}
              data-mapid="clickOpenDemografi"
            />
          </div>
        )}
      </section>
    );

    return <main>{content}</main>;
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  pull_value_sini_object,
  set_value_sini,
  fly_init_update,
  set_demography,
})(SINI_DEMOGRAPHY);
